import React, { useEffect, useState } from 'react';
import { fetchProfessionals, fetchRooms } from '../api';
import CreateBooking from './Tabs/CreateBooking';
import './Booking.css';

function BookingCreatePage() {
  const [professionals, setProfessionals] = useState([]);
  const [rooms, setRooms] = useState([]);

  useEffect(() => {
    fetchProfessionals()
      .then(data => {
        const professionalsList = Object.entries(data.config.profissionais).map(([name, details]) => ({
          name: name,
          ...details
        }));
        setProfessionals(professionalsList);
      })
      .catch(error => console.error('Error fetching professionals:', error));

    fetchRooms()
      .then(data => {
        const roomsList = Object.entries(data.config.salas).map(([name, details]) => ({
          name: name,
          ...details
        }));
        setRooms(roomsList);
      })
      .catch(error => console.error('Error fetching rooms:', error));
  }, []);

  return (
    <div className="booking-container">
      <CreateBooking professionals={professionals} rooms={rooms} />
    </div>
  );
}

export default BookingCreatePage;


